import React from 'react';
import { motion } from 'framer-motion';
import { Calculator, BookOpen, PenTool, Globe2, Clock, Coins, Ruler, MessageSquare, Lightbulb, Map, Sparkles } from 'lucide-react';
export function SubjectsGrid() {
  const subjects = [{
    id: 'rek',
    title: 'Rekenen',
    icon: <Calculator className="w-8 h-8" strokeWidth={2.5} data-id="element-710" />,
    color: 'text-orange-600',
    bg: 'bg-orange-500',
    light: 'bg-orange-50',
    ring: 'border-orange-200',
    badge: '🌱'
  }, {
    id: 'taa',
    title: 'Taal',
    icon: <BookOpen className="w-8 h-8" strokeWidth={2.5} data-id="element-711" />,
    color: 'text-blue-600',
    bg: 'bg-blue-500',
    light: 'bg-blue-50',
    ring: 'border-blue-200',
    badge: '⭐'
  }, {
    id: 'spr',
    title: 'Spelling',
    icon: <PenTool className="w-8 h-8" strokeWidth={2.5} data-id="element-712" />,
    color: 'text-rose-600',
    bg: 'bg-rose-500',
    light: 'bg-rose-50',
    ring: 'border-rose-200',
    badge: '👑'
  }, {
    id: 'topo',
    title: 'Topografie',
    icon: <Globe2 className="w-8 h-8" strokeWidth={2.5} data-id="element-713" />,
    color: 'text-emerald-600',
    bg: 'bg-emerald-500',
    light: 'bg-emerald-50',
    ring: 'border-emerald-200',
    badge: '🌱'
  }, {
    id: 'tijd',
    title: 'Tijd',
    icon: <Clock className="w-8 h-8" strokeWidth={2.5} data-id="element-714" />,
    color: 'text-sky-600',
    bg: 'bg-sky-500',
    light: 'bg-sky-50',
    ring: 'border-sky-200',
    badge: '⭐'
  }, {
    id: 'geld',
    title: 'Geld',
    icon: <Coins className="w-8 h-8" strokeWidth={2.5} data-id="element-715" />,
    color: 'text-yellow-600',
    bg: 'bg-yellow-500',
    light: 'bg-yellow-50',
    ring: 'border-yellow-200',
    badge: '🌱'
  }, {
    id: 'met',
    title: 'Meten',
    icon: <Ruler className="w-8 h-8" strokeWidth={2.5} data-id="element-716" />,
    color: 'text-teal-600',
    bg: 'bg-teal-500',
    light: 'bg-teal-50',
    ring: 'border-teal-200',
    badge: '⭐'
  }, {
    id: 'sww',
    title: 'Werkwoorden',
    icon: <MessageSquare className="w-8 h-8" strokeWidth={2.5} data-id="element-717" />,
    color: 'text-fuchsia-600',
    bg: 'bg-fuchsia-500',
    light: 'bg-fuchsia-50',
    ring: 'border-fuchsia-200',
    badge: '🌱'
  }, {
    id: 'stu',
    title: 'Studievaardigheden',
    icon: <Lightbulb className="w-8 h-8" strokeWidth={2.5} data-id="element-718" />,
    color: 'text-purple-600',
    bg: 'bg-purple-500',
    light: 'bg-purple-50',
    ring: 'border-purple-200',
    badge: '⭐'
  }, {
    id: 'get',
    title: 'Getallen',
    icon: <Map className="w-8 h-8" strokeWidth={2.5} data-id="element-719" />,
    color: 'text-indigo-600',
    bg: 'bg-indigo-500',
    light: 'bg-indigo-50',
    ring: 'border-indigo-200',
    badge: '👑'
  }];
  return <section id="vakken" className="py-20 lg:py-32 bg-[#FFF9F2]" data-id="element-720">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-721">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-722">
          <motion.div initial={{
          opacity: 0,
          y: 10,
          rotate: 3
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotate: 2
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-rose-100 text-rose-700 border border-rose-200 px-3 py-1.5 rounded-full text-[10px] font-black uppercase tracking-[0.2em] mb-6" data-id="element-723">
            <Sparkles className="w-3.5 h-3.5" data-id="element-724" />
            Tien vakken
          </motion.div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-slate-900 mb-6 tracking-tight" data-id="element-725">
            Alles wat ze <br data-id="element-726" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-amber-500" data-id="element-727">
              nodig hebben
            </span>
          </h2>
          <p className="text-lg text-slate-600 font-medium" data-id="element-728">
            10 complete vakken, meer dan 100 vaardigheden. Van de tafels tot
            werkwoordspelling, alles zit erin.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-y-12 gap-x-6" data-id="element-729">
          {subjects.map((subject, idx) => <motion.div key={subject.id} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05,
          type: 'spring',
          bounce: 0.5
        }} whileHover={{
          y: -5,
          scale: 1.05
        }} className="flex flex-col items-center cursor-default" data-id="element-730">
              <motion.div className="relative mb-4" animate={{
            y: [0, -3, 0]
          }} transition={{
            duration: 4 + idx % 3,
            ease: 'easeInOut',
            repeat: Infinity,
            delay: idx % 5 * 0.2
          }} data-id="element-731">
                {/* Badge */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-20 drop-shadow-md bg-white rounded-full px-1 py-0.5 border border-slate-100 flex items-center justify-center text-xl" data-id="element-732">
                  {subject.badge}
                </div>

                {/* Bubble */}
                <div className={`w-24 h-24 rounded-full border-4 ${subject.ring} bg-white flex items-center justify-center p-1.5 shadow-sm`} data-id="element-733">
                  <div className={`w-full h-full rounded-full ${subject.bg} text-white flex items-center justify-center shadow-inner`} data-id="element-734">
                    {subject.icon}
                  </div>
                </div>
              </motion.div>

              <h3 className="font-bold text-slate-800 text-center text-sm leading-tight max-w-[100px]" data-id="element-735">
                {subject.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}